// Two tenants can share a company name, so the platform pages show the tenant id and the saved address with it.
interface TenantAddress {
  street?: string | null;
  city?: string | null;
  state?: string | null;
  zip?: string | null;
  country?: string | null;
}

const clean = (v?: string | null) => (v ?? '').trim();

/** "1 Main St, Caldwell, Idaho 83605": only what is saved, '' when nothing is. */
export function formatTenantAddress(address?: TenantAddress | null): string {
  if (!address) return '';
  const stateZip = [clean(address.state), clean(address.zip)].filter(Boolean).join(' ');
  return [clean(address.street), clean(address.city), stateZip].filter(Boolean).join(', ');
}

/** The dropdown label: company name and tenant id. */
export function tenantOptionLabel(t: { tenant_id: string; company_name: string }): string {
  return `${t.company_name} — ${t.tenant_id}`;
}
